import { Link } from "react-router-dom";

export function AuthShell({ label, heading, sub, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex items-center justify-center bg-muted border-r border-border paper-noise">
        <div className="max-w-md px-10">
          <div className="font-mono-label text-muted-foreground mb-6">{label}</div>
          <h1 className="font-serif-display text-5xl tracking-tighter leading-none mb-6">{heading}</h1>
          <p className="text-muted-foreground">{sub}</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm space-y-6">
          <Link to="/" className="inline-flex items-center gap-2 mb-2">
            <div className="w-7 h-7 bg-foreground text-background grid place-items-center font-serif-display text-lg font-black">D</div>
            <span className="font-serif-display text-xl">DocuMind</span>
          </Link>
          {children}
        </div>
      </div>
    </div>
  );
}
